<template>
    <b-modal
      :id="modalName"
      :ref="modalName"
      :title="title"
      @show="open"
      @hidden="close"
      @ok="ok"
      :hide-header="onlyBody"
      :hide-footer="onlyBody"
      :ok-title="okTitle"
      :cancel-title="cancelTitle"
      :ok-variant="okVariant"
      :cancel-variant="cancelVariant"
    >
        <slot></slot>
    </b-modal>
</template>

<style lang="stylus">

@import '../../style/colors.styl';
@import '../../style/fonts.styl';
@import '../../style/spacing.styl';

.modal-content
    background-color secondary
    border-radius radius-lg
    color black
    font-size 18px
    font-weight 600
    line-height 20px

.modal-body
    border-radius radius-md
    margin 5px
    padding space-md

    @media (max-width: 767px)
      padding space-sm

.modal
    text-align: center
    padding space-sm

@media screen and (min-width: 768px)
  .modal:before
    display: inline-block
    vertical-align: middle
    content: " "
    height: 100%

.modal-dialog
    display: inline-block
    text-align: left
    vertical-align: middle
    margin space-sm
    max-width calc(100% - 16px)
    width 100%

    // Mobile first - small screens
    @media (min-width: 576px)
      max-width 500px
      margin space-md auto

    // Tablets
    @media (min-width: 768px)
      max-width 700px
      margin space-lg auto

    // Small laptops
    @media (min-width: 992px)
      max-width 800px

    // Desktops
    @media (min-width: 1200px)
      max-width 900px

.close
    color accent
    padding space-sm
    font-size 1.5rem

// Responsive form elements inside modal
.modal-body
    .form-group
        margin-bottom space-md

        @media (max-width: 767px)
            margin-bottom space-sm

    .row
        @media (max-width: 767px)
            margin-left 0
            margin-right 0

            > [class*="col-"]
                padding-left 0
                padding-right 0
                margin-bottom space-sm

</style>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Title'
    },
    prevent: {
      type: Boolean,
      default: false
    },
    onlyBody: {
      type: Boolean,
      default: false
    },
    okTitle: {
      type: String,
      default: 'Ok'
    },
    cancelTitle: {
      type: String,
      default: 'Cancelar'
    },
    okVariant: {
      type: String,
      default: 'primary'
    },
    cancelVariant: {
      type: String,
      default: 'danger'
    }
  },
  computed: {
    modalName () {
      return this.name + '-modal'
    }
  },
  mounted () {
    // Removido para evitar que o modal abra automaticamente
  },
  methods: {
    ok (e) {
      if (this.prevent) e.preventDefault()
      // ...
      this.$emit('ok')
    },
    open () {
      // ...
      this.$emit('open')
    },
    close () {
      // ...
      if (!this.prevent) {
        this.$nextTick(() => {
          this.$bvModal.hide(this.modalName)
        })
      }
      this.$emit('close')
    }
  }
}
</script>
